import { render, staticRenderFns } from "./xskUploadXlsx.vue?vue&type=template&id=4a84ab75&scoped=true&"
import script from "./xskUploadXlsx.vue?vue&type=script&lang=js&"
export * from "./xskUploadXlsx.vue?vue&type=script&lang=js&"
import style0 from "./xskUploadXlsx.vue?vue&type=style&index=0&id=4a84ab75&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a84ab75",
  null
  
)

export default component.exports